































import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/requestExt'
import navigater from '@/components/navigater.vue'
// import swiper from '@/components/swiper.vue'

export default Vue.extend({
    components: {
        navigater,
    },
    data() {
        return {
            id: '',
            loading: true,
            navTitle: '',
            imageData: [
            ],
            dataObj: {},
            xingIndex: 0,
            comment: '',
        }
    },
    created() {
        // console.log(this.$route.params.id)
        this.id = this.$route.params.id
        this.getData(this.id)
    },
    methods: {
           getData(id: any) {
            request.get(`/api/course_ware/${id}`).then((result) => {
                console.log(result)
                this.navTitle = result.name // 课程名称
                const preview = {
                    imgUrl: result.preview,
                }
                // @ts-ignore
                this.imageData.push(preview)
                this.dataObj = result
                this.loading = false
            }).catch((err) => {
                console.log(err)
                this.loading = false
            })
        },
        changeXing(item: any) {
            this.xingIndex = item
        },
        submit() {

        if (this.xingIndex < 1) {
            this.$Message.error('请选择评分')
            return
        }

        if (this.comment === '') {
            this.$Message.error('请输入评价')
            return
        }

        const params = {
            score: String(this.xingIndex),
            comment: this.comment,
            wareId: this.id,
        }

        request.post('/api/courseWareEva/evaluate', params)
            .then((res) => {
                    this.$Message.success('保存成功!')
                    this.$router.go(-1)

            })

        },

    },
    filters: {
        getTime(value: any) {
            if (value) {
                return moment(value).format('YYYY/MM/DD HH:mm:ss')
            } else {
                return '- -'
            }
        },
    },
})
